/** Styl kalendáře k tématu Erma */
export const DatepickerStyles = {
  header: {
    background: 'var(--erma-secondary-0)',
  },
  panel: {
    background: 'var(--erma-secondary-0)',
    padding: '1rem'
  },
  date: {
    hoverBackground: 'var(--erma-secondary-100)',
    selectedBackground: 'var(--erma-primary-700)',
    rangeSelectedBackground: '{highlight.background}',
    selectedColor: 'var(--erma-primary-0)',
    rangeSelectedColor: 'var(--erma-primary-700)',
    width: '2rem',
    height: '2rem',
    borderRadius: '50%',
    padding: '0.25rem',
    focusRing: {
      width: '1rem',
      style: '',
      color: 'var(--erma-primary-400)',
      offset: '.5rem',
      shadow: ''
    }
  },
  dayView: {
    margin: '0.5rem 0 0 0'
  },
  today: {
    background: 'var(--erma-secondary-200)'
  },
  weekDay: {
    padding: '1rem',
    fontWeight: '500'
  },
  monthView: {
    margin: '0.5rem 0 0 0'
  },
  month: {
    padding: '0.375rem',
    borderRadius: 'var(--erma-border-radius-xs)'
  },
  yearView: {
    margin: '0.5rem 0 0 0'
  },
  year: {
    padding: '0.375rem',
    borderRadius: 'var(--erma-border-radius-sm)'
  },
  timePicker: {
    padding: '0.5rem 0 0 0',
    gap: '0.5rem',
    buttonGap: '0.25rem'
  },
  title: {
    gap: '0.5rem',
    fontWeight: '500'
  },
  dropdown: {
    background: 'var(--erma-primary-700)',
    color: 'var(--erma-primary-0)',
    hover: {
      background: 'var(--erma-primary-500)',
      color: 'var(--erma-primary-0)'
    }
  }
};
